export default [
  {
    codeCategory: "C1",
    title: "Identificación del centro de trabajo",
    subCategories: [
      {
        codeSubCategory: "SC1",
        title: "",
        text: "",
        questions: [
          {
            codeQuestion: "Q1",
            question: "Nombre del Centro de Trabajo",
            help: "",
            responses: [],
            type: "TEXT",
          },
          {
            codeQuestion: "Q2",
            question: "Tipo",
            help: "",
            responses: [
              { a: "Casa Matriz" },
              { b: "Sucursal" },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q3",
            question: "Dirección",
            help: "",
            responses: [],
            type: "TEXT",
          },
          {
            codeQuestion: "Q4",
            question: "Zona",
            help: "",
            responses: [
              { a: "Urbana" },
              { b: "Rural" },
            ],
            type: "JUST_ONE",
          },
        ],
      },
    ],
    order: 1,
  },
  {
    codeCategory: "C2",
    title: "Trabajadores",
    subCategories: [
      {
        codeSubCategory: "SC1",
        title: "",
        text: "",
        questions: [
          {
            codeQuestion: "Q5",
            question: "¿Cuántas personas trabajan en este centro de trabajo?",
            help: "",
            responses: [
              { a: "Nº de Hombres" },
              { b: "Nº de Mujeres" },
            ],
            type: "COMPOSITE",
          },
          {
            codeQuestion: "Q6",
            question: "¿Cuántos de ellos se encuentran en situación de discapacidad?",
            help: "",
            responses: [
              { a: "Nº de Hombres" },
              { b: "Nº de Mujeres" },
            ],
            type: "COMPOSITE",
          },
        ],
      },
    ],
    order: 2,
  },
  {
    codeCategory: "C3",
    title: "Organización del trabajo",
    subCategories: [
      {
        codeSubCategory: "SC1",
        title: "Sobre la jornada laboral",
        text: "",
        questions: [
          {
            codeQuestion: "Q7",
            question: "¿Qué días de la semana se trabaja habitualmente en el centro de trabajo?",
            help: "Especificar los días en que el centro de trabajo opera con sus trabajadores. No considerar personal de seguridad o de mantención ajenos a la operación del centro de trabajo.",
            responses: [
              { a: "Lunes." },
              { b: "Martes." },
              { c: "Miércoles." },
              { d: "Jueves." },
              { e: "Viernes." },
              { f: "Sábado." },
              { g: "Domingo." },
            ],
            type: "AT_LEAST_ONE",
          },
          {
            codeQuestion: "Q8",
            question: "¿Cuáles son los horarios de trabajo en el centro de trabajo?",
            help: "Nos interesa conocer si el centro de trabajo opera de día o de noche (los horarios son referenciales)",
            responses: [
              { a: "Diurno (entre 8:00 y  19:59)." },
              { b: "Nocturno (entre 20:00 y 7:59)." },
            ],
            type: "AT_LEAST_ONE",
          },
        ],
      },
      {
        codeSubCategory: "SC2",
        title: "Sobre la flexibilidad horaria",
        text: "",
        questions: [
          {
            codeQuestion: "Q9",
            question: "¿Los trabajadores tienen acceso a un rango horario flexible para comenzar su jornada laboral?",
            help: "Considerar, por ejemplo, si los trabajadores pueden ingresar entre 8:00 y 9:00 y salir entre 18:00 y 19:00.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q10",
            question: "¿Los trabajadores pueden ajustar su jornada diaria para acortar uno o más días a la semana?",
            help: "Considerar, por ejemplo, si los trabajadores trabajan más horas de lunes a jueves, para salir más temprano los viernes.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
        ],
      },
      {
        codeSubCategory: "SC3",
        title: "Sobre los mecanismos de registro",
        text: "",
        questions: [
          {
            codeQuestion: "Q11",
            question: "¿Los trabajadores deben registrar su hora de entrada y salida?",
            help: "",
            responses: [
              { a: "Si, todos los trabajadores." },
              { b: "Si, pero solo algunos trabajadores." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
        ],
      },
      {
        codeSubCategory: "SC4",
        title: "Sobre la modalidad de trabajo",
        text: "Por la naturaleza de sus funciones, no todos los trabajadores podrían optar a esta modalidad. Considerar si existe esta alternativa para aquellos trabajadores cuyo trabajo es compatible con esta modalidad.",
        questions: [
          {
            codeQuestion: "Q12",
            question: "¿Los trabajadores pueden optar a trabajar a distancia (teletrabajo)?",
            help: "",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
        ],
      },
    ],
    order: 3,
  },
  {
    codeCategory: "C4",
    title: "Infraestructura y servicios",
    subCategories: [
      {
        codeSubCategory: "SC1",
        title: "Estacionamientos",
        text: "Especificar los estacionamientos disponibles para el uso de los trabajadores, y no los destinados a clientes o proveedores.",
        questions: [
          {
            codeQuestion: "Q13",
            question: "En el centro de trabajo ¿cuántos estacionamientos para vehículos hay disponibles para los trabajadores?",
            help: "",
            responses: [],
            type: "NUMBER",
          },
          {
            codeQuestion: "Q14",
            question: "En el centro de trabajo ¿cuántos estacionamientos para bicicletas hay disponibles para los trabajadores?",
            help: "",
            responses: [],
            type: "NUMBER",
          },
        ],
      },
      {
        codeSubCategory: "SC2",
        title: "Transporte",
        text: "Considerar buses, minivan, servicios de taxis/radiotaxis u otro destinado por parte de la empresa al trabajador, exclusivamente para el traslado completo o parte de éste, desde el hogar al centro de trabajo y/o viceversa (no para asistir a reuniones u otro destino durante la jornada de trabajo).",
        questions: [
          {
            codeQuestion: "Q15",
            question: "¿Se ofrecen servicios de transporte a los trabajadores para acercarlos al centro de trabajo y/o a su domicilio?",
            help: "",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
        ],
      },
      {
        codeSubCategory: "SC3",
        title: "Alimentación",
        text: "",
        questions: [
          {
            codeQuestion: "Q16",
            question: "El centro de trabajo ¿cuenta con servicio de alimentación (casino)?",
            help: "Considerar si se ofrece comida a los trabajadores al interior del centro de trabajo, independiente si es pagada por ellos en su totalidad o no.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q17",
            question: "El centro de trabajo ¿cuenta con comedor o zona exclusiva para que los trabajadores puedan comer durante el horario de colación?",
            help: "Indicar si el centro de trabajo cuenta con un espacio para que el trabajador lleve su propia comida y consumirla en dicho lugar.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
        ],
      },
      {
        codeSubCategory: "SC4",
        title: "Camarines",
        text: "Indicar si cuenta con camarines o algún espacio similar.",
        questions: [
          {
            codeQuestion: "Q18",
            question: "El centro de trabajo ¿cuenta con instalaciones que permitan a los trabajadores asearse y cambiarse de ropa?",
            help: "",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
        ],
      },
    ],
    order: 4,
  },
  {
    codeCategory: "C5",
    title: "Sobre el entorno del centro de trabajo",
    subCategories: [
      {
        codeSubCategory: "SC1",
        title: "",
        text: "Para responder las siguientes preguntas, debe considerar el entorno al centro de trabajo (500 metros a la redonda). Te recomendamos recorrer a pie el entorno al centro de trabajo, observando cada una de las situaciones planteadas a continuación.",
        questions: [
          {
            codeQuestion: "Q19",
            question: "¿Hay lugares sin vereda?",
            help: "Identifique si hay secciones de la vía que no cuenten con vereda para el tránsito de peatones.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q20",
            question: "¿Hay veredas en mal estado?",
            help: "Indique si existen veredas deterioradas o con superficies irregulares.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q21",
            question: "¿Hay calles en mal estado?",
            help: "Indique si existen calles deterioradas (hoyos) o con superficies irregulares.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q22",
            question: "¿Hay ciclovías en mal estado?",
            help: "Indique si existen ciclovías deterioradas (con hoyos o con superficies irregulares).",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q23",
            question: "¿Hay lugares con poca iluminación?",
            help: "Indique si existen lugares sin iluminación o con iluminación deficiente.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q24",
            question: "¿Hay lugares solitarios?",
            help: "Indique si existen lugares deshabitados o con poco flujo de personas transitando.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q25",
            question: "¿Hay sectores donde se cometan actos delictuales?",
            help: "Indique si existen lugares donde se generen con frecuencia actos como robos, hurtos, asaltos, acoso.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q26",
            question: "¿Hay cruces peligrosos?",
            help: "Indique si existen cruces donde exista peligro para peatones, ciclistas o conductores (mucho flujo, poca visibilidad, falta de señalización, etc.).",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q27",
            question: "¿Hay lugares en que los peatones deben cruzar de manera temeraria?",
            help: "Indique si los peatones cruzan por lugares no habilitados para ello poniendo en riesgo su seguridad",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q28",
            question: "¿Hay paradas de transporte público en mal estado?",
            help: "Indique si existen paradas en mal estado (sin techo o con suelo en mal estado).",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q29",
            question: "¿Hay tránsito de vehículos a alta velocidad?",
            help: "Indique si en el entorno transitan vehículos a velocidad imprudente.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
          {
            codeQuestion: "Q30",
            question: "¿Hay presencia de perros vagos?",
            help: "Indique si en el entorno hay perros que puedan ser un peligro para los trabajadores.",
            responses: [
              { a: "Si." },
              { b: "No." },
            ],
            type: "JUST_ONE",
          },
        ],
      },
    ],
    order: 5,
  },
];
